import React from 'react';
import PropTypes from 'prop-types';
import { FaSpinner } from 'react-icons/fa';
import './LoadScreen.scss';

class LoadScreen extends React.PureComponent {
  render() {
    const { loading } = this.props;
    return (
      <div className="loader">
        <div className="loader__icon">
          <FaSpinner className="fa-spin" />
        </div>
        <div className="loader__text">{loading}</div>
      </div>
    );
  }
}

LoadScreen.propTypes = {
  loading: PropTypes.string.isRequired,
};

export default LoadScreen;
